import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Header from '../../components/Header';
import axios from '../../Axiosinstance'
import { useParams } from 'react-router-dom';
import { Table, Typography, Box, Paper, Grid } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaTrash } from 'react-icons/fa';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { Card, CardContent, IconButton, Tooltip , Dialog, DialogTitle, DialogActions,DialogContent } from "@mui/material";

import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Import the CSS for toastify
import { useNavigate } from 'react-router-dom';  // For navigation
import { motion } from "framer-motion"; // For smooth animations
import Button from '@mui/material/Button';
import Loader from '../../Loader';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { buttonBackgroundColor,timestamp } from '../../common';


const App = ({ setSubmitted }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [selectedCurriculum, setSelectedCurriculum] = useState({ id: '', name: '' });
  const [curriculumData, setCurriculumData] = useState([]);
  const { curriculumid, intakeId } = useParams();
  const [selectedFileType, setSelectedFileType] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [selectedPublicPreview, setSelectedPublicPreview] = useState('');
  const [selectedFor, setSelectedFor] = useState('');
  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [curriculumName, setCurriculumName] = useState('');
  const [isNameValid, setIsNameValid] = useState(true);
  const [uploadStatus, setUploadStatus] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false); // State to control modal visibility
  const [curriculumIdToDelete, setCurriculumIdToDelete] = useState(null);
  const [selectedBatchType, setSelectedBatchType] = useState('');
  // console.log(curriculumid, intakeId);
  // const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';
  const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';


  const jwtToken = localStorage.getItem('jwtToken');

  // Set the Authorization header if the token exists
  const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};

  // const handleUpload = () => {
  //   if (file) {
  //     const formData = new FormData();
  //     formData.append('file', file);
  //     formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
  //     formData.append('public_id', 'LMS/curriculum/' + file.name);


  //     fetch(CLOUDINARY_URL, {
  //       method: 'POST',
  //       body: formData,
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.secure_url !== '') {
  //           const uploadedFileUrl = data.secure_url;
  //           // console.log('File uploaded successfully:', uploadedFileUrl); // take the uploadedFileUrl and assign to i mention place
  //           setUploadStatus('File uploaded successfully.');
  //         }
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         setUploadStatus('An error occurred during upload.');
  //       });
  //   } else {
  //     setUploadStatus('Please select a file before uploading.');
  //   }
  // };


  const handleNewButtonClick = () => {
    setShowPopup(true);
    setShowMessage(true);
    setTimeout(() => {
      setShowMessage(false);
    }, 2000);
  };


  const handleClosePopup = () => {
    setShowPopup(false);
  };


  const handleSavePopup = (e) => {

    e.preventDefault();
    if (curriculumName.trim() === '') {
      // Display a warning message or prevent saving
      setIsNameValid(false);
      return;
    }
    const newCurriculumName = document.getElementById('curriculumInput').value;


    const pathSegments = window.location.pathname.split('/');
    const courseid = pathSegments[pathSegments.length - 1];
    const curriculumData = {
      name: newCurriculumName,
      courseid: curriculumid,
      createdAt: new Date().toISOString(),
    };


    axios.post('curriculum', curriculumData, { headers })
      .then((response) => {
        // console.log('Curriculum saved successfully:', response.data);


        // After successfully saving, fetch the latest curriculum data
        axios.get('curriculum', { headers })
          .then((response) => {
            const filteredData = response.data.filter(curriculum => curriculum.courseid === parseInt(curriculumid));
            setCurriculumData(filteredData);
          })
          .catch((error) => {
            console.error('Error fetching curriculum data:', error);
          });
      })
      .catch((error) => {
        console.error('Error saving curriculum:', error);
      });
    setCurriculumName('');
    setShowPopup(false); // Close the popup after saving
  };



  //material list name api

  useEffect(() => {
    // Fetch curriculum data from the API
    axios.get('curriculum', { headers })
      .then((response) => {
        // Filter the curriculum data based on the ID
        const filteredData = response.data.filter(curriculum => curriculum.courseid === parseInt(curriculumid));
        // Update the state with the filtered curriculum data


        setCurriculumData(filteredData);
      })
      .catch((error) => {
        console.error('Error fetching curriculum data:', error);
      });
  }, [curriculumid]);




  const [isUploaded, setIsUploaded] = useState(false);
  const handleFileChange = (e) => {
    const fileToUpload = e.target.files[0];


    if (fileToUpload) {
      setIsUploading(true);


      const formData = new FormData();
      formData.append('file', fileToUpload);
      formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
      formData.append('public_id', 'LMS/curriculum/' + fileToUpload.name +' - '+ timestamp);


      fetch(CLOUDINARY_URL, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.secure_url !== '') {
            const uploadedFileUrl = data.secure_url;
            setUploadedFileUrl(uploadedFileUrl);
            setIsUploading(false);

            // Show success toast when file is uploaded successfully
            toast.success('File uploaded successfully!');

            // Optionally log the uploaded file URL
            // console.log('File uploaded successfully:', uploadedFileUrl);
          }
        })
        .catch((err) => {
          console.error(err);
          setUploadStatus('An error occurred during upload');
          setIsUploading(false);
          // Show error toast if the upload fails
          toast.error('Error during file upload!');
        });


      // Set the selected file type based on the accepted formats
      const acceptTypes = getAcceptTypes();
      for (const type in validFileTypes) {
        if (acceptTypes.includes(validFileTypes[type])) {
          setSelectedFileType(type);
          break;
        }
      }
    }
  };


  const handleSubmitButtonHover = (e) => {
    e.target.style.backgroundColor = '#28a745';
  };


  const handleSubmitButtonLeave = (e) => {
    e.target.style.backgroundColor = 'green';
  };

  const handleDelete = (id) => {
    setCurriculumIdToDelete(id);
    setShowConfirmationModal(true);
  };

  const handleConfirmDelete = () => {
    // Perform the deletion logic here using curriculumIdToDelete
    axios.delete(`curriculum/${curriculumIdToDelete}`, { headers })
      .then(response => {
        if (response.status === 200) {
          const updatedCourses = curriculumData.filter((curriculum) => curriculum.id !== curriculumIdToDelete);
          setCurriculumData(updatedCourses);
        }
      })
      .catch(error => {
        console.error('Error deleting course:', error);
        // You can log the error or display an error message here.
      })
      .finally(() => {
        setShowConfirmationModal(false);
        setCurriculumIdToDelete(null);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationModal(false);
    setCurriculumIdToDelete(null);
  };


  const validFileTypes = {
    ppt: '.ppt, .pptx',
    pdf: '.pdf',
    audio: '.mp3',
    video: '.mp4, .mov, .avi', // Add more video file extensions if needed
  };


  const getAcceptTypes = () => {
    if (selectedFileType === 'ppt') {
      return validFileTypes.ppt;
    } else if (selectedFileType === 'pdf') {
      return validFileTypes.pdf;
    } else if (selectedFileType === 'video') {
      return validFileTypes.video;
    }
    else if (selectedFileType === 'audio') {
      return validFileTypes.audio;
    } else {
      return '';
    }
  };

  const renderInputField = () => {
    if (selectedFileType === 'youtube link') {
      return (
        <div className="mb-3">
          <label htmlFor="youtubeLink" className="text-start d-block">
            Paste YouTube Link
          </label>
          <input
            type="text"
            id="youtubeLink"
            className="form-control"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      );
    } else if (selectedFileType === 'text') {
      return (
        <div className="mb-3">
          <label htmlFor="textInput" className="text-start d-block">
            Enter Text
          </label>
          <ReactQuill
            value={inputValue}
            onChange={setInputValue}
            modules={{
              toolbar: [
                [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ['bold', 'italic', 'underline'],
                ['link'],
                [{ 'align': [] }],
              ],
            }}
            formats={[
              'header',
              'font',
              'list',
              'bullet',
              'bold',
              'italic',
              'underline',
              'link',
              'align',
            ]}
          />
        </div>
      );
    }
    return null;
  };


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // console.log("i have been clicked");

    // Initialize an object to store error messages
    const errors = {};

    // Validate form fields
    const studentName = document.getElementById('name').value;
    const selectedCurriculumId = selectedCurriculum.id;
    const selectedPublicPreviewValue = selectedPublicPreview;
    const selectedForValue = selectedFor;
    const selectedFileTypeValue = selectedFileType;

    if (!studentName) {
      errors.studentName = 'Please enter the student name.';
    }

    if (!selectedCurriculumId) {
      errors.selectedCurriculum = 'Please select a curriculum.';
    }

    // if (!selectedPublicPreviewValue) {
    //   errors.selectedPublicPreview = 'Please select an option for public preview.';
    // }

    // if (!selectedForValue) {
    //   errors.selectedFor = 'Please select an option for "For".';
    // }

    if (!selectedFileTypeValue) {
      errors.selectedFileType = 'Please select a file type.';
    }

    // Check if there are any errors
    if (Object.keys(errors).length > 0) {
      // If there are errors, update the state or display the errors in a way that suits your UI
      console.log('Form validation errors:', errors);
      return;
    }

    // Rest of your code for form submission
    const intakeIdValue = selectedBatchType === "allBatches" ? null : intakeId;

    // Prepare the data object
    const formData = {
      sectionName: studentName,
      selectCurriculum: selectedCurriculum.name,
      // for_access: document.getElementById('for').value,
      type: selectedFileType,
      // publicReview: selectedPublicPreview === 'Type 1',
      curriculum_id: selectedCurriculumId,
      course_id: curriculumid,
      fileUrl: (selectedFileType === 'youtube link' || selectedFileType === 'text') ? inputValue : uploadedFileUrl,
      batch_id: intakeIdValue,
    };

    try {
      // Send a POST request to the API endpoint
      const response = await axios.post('uploadcurriculum', formData, { headers });

      // Show success toast
      toast.success('Form submitted successfully!', {
        autoClose: 3000,
        onClose: () => {

        }
      });

      // Reset the form fields if needed
      document.getElementById('name').value = '';
      setSelectedCurriculum({ id: '', name: '' });
      // document.getElementById('for').value = '';
      setSelectedFileType('');
      setInputValue('');

      // Clear the uploaded file field and reset the upload status
      setUploadedFileUrl('');
      setUploadStatus('');

      // Clear the "For Public Preview" and "For" select fields
      setSelectedPublicPreview('');
      setSelectedFor('');

      setSubmitted(prev => !prev);

    } catch (error) {
      // Handle errors, for example, show an error message to the user
      toast.error('Error submitting the form.');
      console.error('Error submitting the form:', error);
    }
  };




  const handleInputChange = (event) => {
    const value = event.target.value;
    setCurriculumName(value);
    setIsNameValid(value.trim() !== ''); // Simple validation: non-empty input is considered valid
  };

  console.log(curriculumData, "test")

  const theme = useTheme();
  const isLaptop = useMediaQuery('(min-width:600px) and (max-width:1400px)'); console.log('isLaptop', isLaptop)
  // console.log('isLaptop',isLaptop)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div style={{ marginTop: isMobile ? '50px' : isLaptop ? '0px' : '-70px', }}>



      <div className="container " style={{ maxWidth: '1320px' }}>
        <br />
        <Box
          sx={{
            backgroundColor: '#fff',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
            padding: '20px',
            borderRadius: '8px',
          }}
        >

          <div className=" ">

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
              }}
            >
              <h3
                style={{
                  fontSize: '24px',
                  color: '#03396c',
                  fontWeight: '600',
                  margin: 0,
                }}
              >
                Material List
              </h3>

              <Button
                onClick={handleNewButtonClick}
                variant="primary"
                style={{
                  background: '#03396c',
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: '500',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <i className="bi bi-file-earmark-plus me-2"></i>
                New Material
              </Button>
            </div>


            {showPopup && (
              <div
                style={{
                  marginTop: '24px',
                  padding: '16px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                }}
              >
                {/* Input, Save, and Cancel buttons */}
                <div className="d-flex flex-column flex-sm-row align-items-stretch gap-2">
                  <div style={{ flexGrow: 1 }}>
                    <input
                      type="text"
                      id="curriculumInput"
                      placeholder="Enter Material name"
                      className={`form-control ${isNameValid ? '' : 'is-invalid'}`}
                      style={{
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        padding: '12px',
                        fontSize: '16px',
                      }}
                      value={curriculumName}
                      onChange={handleInputChange}
                      required
                    />
                    {!isNameValid && (
                      <div
                        className="invalid-feedback"
                        style={{
                          display: 'block',
                          color: '#dc3545',
                          fontSize: '14px',
                          marginTop: '6px',
                          marginLeft: '4px',
                        }}
                      >
                        Please enter a valid Material name.
                      </div>
                    )}
                  </div>

                  <Button
                    onClick={handleSavePopup}
                    sx={{
                      backgroundColor: '#03396c',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: { xs: '14px', sm: '16px' },
                      fontWeight: 300,
                      padding: { xs: '8px 16px', sm: '10px 20px' },
                      minWidth: '80px',
                      '&:hover': {
                        backgroundColor: '#03396c', // same as default
                        color: 'white',             // same as default
                      },
                    }}
                  >
                    <i className="bi bi-check-circle me-1"></i> Save
                  </Button>

                  <Button
                    onClick={handleClosePopup}
                   
                    sx={{
                      backgroundColor: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: { xs: '14px', sm: '16px' },
                      fontWeight: 300,
                      padding: { xs: '8px 16px', sm: '10px 20px' },
                      minWidth: '80px',
                      '&:hover': {
                        backgroundColor: '#dc3545', // same as default
                        color: 'white',             // same as default
                      },
                    }}
                  >
                    <i className="bi bi-x-circle me-1"></i> Cancel
                  </Button>
                </div>
              </div>
            )}


            <hr
              style={{
                marginTop: '16px',
                marginBottom: '20px',
                borderTop: '2px solid #ddd',
              }}
            />
            <Table
              sx={{
                backgroundColor: '#ffffff',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                tableLayout: 'fixed',
                width: '100%',
              }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '10px', fontSize: '18px' }}>Name</th>
                  <th style={{ textAlign: 'center', padding: '10px', fontSize: '18px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {curriculumData.map((curriculum) => (
                  <tr key={curriculum.id}>
                    <td style={{ padding: '15px', fontSize: '18px' }}>{curriculum.name}</td>
                    <td style={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => handleDelete(curriculum.id)}
                        title="Delete Material"
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}


              </tbody>
            </Table>
            <br />

            <Modal show={showConfirmationModal} onHide={handleCancelDelete} centered>
              <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: 'none' }}>
                <Modal.Title>Confirm Deletion</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: '20px' }}>Are you sure you want to delete this material?</Modal.Body>
              <Modal.Footer style={{ borderTop: 'none' }}>
                <Button variant="secondary" onClick={handleCancelDelete} style={{ backgroundColor: '#6c757d', color: 'white', marginRight: "10px" }}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleConfirmDelete} style={{ backgroundColor: '#dc3545', color: 'white' }}>
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>


            <h3
              style={{
                fontSize: '24px',
                color: '#03396c',
                fontWeight: '600',
                marginBottom: '0',
                marginRight: '20px',
              }}
            >Upload Material</h3>
            <hr
              style={{
                marginTop: '16px',
                marginBottom: '20px',
                borderTop: '2px solid #ddd',
              }}
            />
            <form onSubmit={handleFormSubmit}>
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)", // Two modules per row
                gap: "15px", // Space between the module cards
              }}>
                <div className="mb-3" >
                  <label htmlFor="name" className="text-start d-block">
                    Section Name
                  </label>
                  <input required type="text" id="name" className="form-control" placeholder="Enter name" style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="Material" className="text-start d-block">
                    Select Material
                  </label>

                  {console.log("curriculumData", curriculumData)}


                  <select
                    required
                    id="curriculum"
                    className="text-start d-block"
                    value={selectedCurriculum.id}
                    onChange={(e) => {
                      const curriculumName = e.target.options[e.target.selectedIndex].text;
                      setSelectedCurriculum({ id: e.target.value, name: curriculumName });
                    }}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}


                  >
                    <option value="">Select a Material</option>
                    {curriculumData.map((curriculum) => (
                      <option key={curriculum.id} value={curriculum.id}>
                        {curriculum.name}
                      </option>
                    ))}
                  </select>




                </div>





                <div className="mb-3">
                  <label htmlFor="type" className="text-start d-block">
                    Type
                  </label>
                  <select
                    required
                    id="type"
                    className="text-start d-block"
                    value={selectedFileType}
                    onChange={(e) => {
                      setSelectedFileType(e.target.value);
                    }}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}


                  >
                    <option value="">Select a type</option>
                    <option value="ppt">PPT</option>
                    <option value="pdf">PDF</option>
                    <option value="video">Video</option>
                    <option value="audio">Audio</option>
                    <option value="youtube link">Youtube Link</option>
                    <option value="text">Text</option>
                    {/* Add other options as needed */}
                  </select>
                </div>
                {renderInputField()}

                {selectedFileType && selectedFileType !== 'youtube link' && selectedFileType !== 'text' && (
                  <div className="mb-3">
                    <label htmlFor="file" className="text-start d-block">
                      Choose {selectedFileType.toUpperCase()} file
                    </label>
                    <input
                      required
                      type="file"
                      id="file"
                      className="form-control"
                      accept={getAcceptTypes()}
                      onChange={handleFileChange}
                    />
                    {isUploading && <p>Uploading...</p>}

                  </div>
                )}

                {/* <div className="mb-3">
                  <label htmlFor="batchSelection" className="text-start d-block">
                    Batch Selection
                  </label>
                  <select
                    required
                    id="batchSelection"
                    className="form-select"
                    value={selectedBatchType}
                    onChange={(e) => setSelectedBatchType(e.target.value)}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                  >
                    <option value="">Select an option</option>
                    <option value="allBatches">All Batches</option>
                    <option value="specificBatches">Current Batch</option>
                  </select>
                </div> */}

              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  onMouseOver={handleSubmitButtonHover}
                  onMouseLeave={handleSubmitButtonLeave}
                  type="submit"
                  disabled={isUploading || !selectedFileType}
                  style={{backgroundColor: 'green',
                    color: 'white',}}
                // sx={{
                //   backgroundColor: 'green',
                //   color: 'white',
                //   padding: '8px 15px',
                //   borderRadius: '4px',
                //   textTransform: 'none', // Optional: keep the text as "Submit" instead of "SUBMIT"
                //   '&:hover': {
                //     backgroundColor: 'darkgreen', // Optional: adjust hover color
                //   },
                // }}
                >
                  Submit
                </Button>
              </div>
            </form>
       <ToastContainer
              position="bottom-right" // 👈 Change to bottom-right, bottom-center, etc.
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </Box>
      </div>
    </div>
  );
};


const extractYouTubeVideoId = (url) => {
  // Extract the video ID from the YouTube URL
  const videoId = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?feature=player_embedded&v=|embed\/watch\?feature=player_embedded&v=))([^&\n?#]+)/);
  return videoId ? videoId[1] : null;
};


const Key = () => {
  const { curriculumid, intakeId } = useParams();
  const [curriculumData, setCurriculumData] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [selectedContentType, setSelectedContentType] = useState(null);
  const [selectedContentUrl, setSelectedContentUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [curriculumToDelete, setCurriculumToDelete] = useState(null);
  const handleShowModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setModalContent(null);
    setShowModal(false);
  };

  const jwtToken = localStorage.getItem('jwtToken');

  // Set the Authorization header if the token exists
  const headers = jwtToken ? { Authorization: `Bearer ${jwtToken}` } : {};

  useEffect(() => {
    // Assuming curriculumid is defined elsewhere
    if (curriculumid) {
      axios.get(`/uploadcurriculums/curriculm?courseId=${curriculumid}`, { headers })
        .then((response) => {
          setCurriculumData(response.data);
          setLoading(false); // Set loading to false when data is loaded
        })
        .catch((error) => {
          console.error('Error fetching data: ', error);
          setLoading(false); // Set loading to false in case of an error
        });
    }
  }, [curriculumid]);  // Dependency on curriculumid to refetch when it changes
  


  const filteredData = curriculumData.filter(
    (curriculum) => curriculum.batch_id === null || curriculum.batch_id === intakeId
  );


  // useEffect(() => {
  //   // Construct the query parameters based on your logic
  //   const batchIdParam = intakeId ? intakeId : null;  // Set batch_id based on intakeId or null

  //   axios
  //     .get(`/admin-view-course-content/${curriculumid}`, {
  //       headers,
  //       params: { batch_id: batchIdParam },  // Pass batch_id as a query parameter
  //     })
  //     .then((response) => {
  //       setCurriculumData(response.data);
  //       setLoading(false); // Set loading to false when data is loaded
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data: ', error);
  //       setLoading(false); // Set loading to false in case of an error
  //     });
  // }, [curriculumid, intakeId]); // Re-run whenever courseId or intakeId changes



  const confirmDelete = () => {
    if (!curriculumToDelete) return;
  
    axios
      .delete(`uploadcurriculum/${curriculumToDelete.id}`, { headers })
      .then(() => {
        
        setSelectedContent(null);
        setSelectedContentType(null);
        setSelectedContentUrl(null);
        reloadCurriculumData();
      })
      .catch((error) => {
        alert('Error deleting curriculum: ' + error);
      })
      .finally(() => {
        setOpenDeleteDialog(false);
        setCurriculumToDelete(null);
      });
  };


  const reloadCurriculumData = () => {
    if (curriculumid) {
      axios.get(`/uploadcurriculums/curriculm?courseId=${curriculumid}`, { headers })
        .then((response) => {
          setCurriculumData(response.data);
          // You might want to reset other state variables if needed
        })
        .catch((error) => {
          console.error('Error fetching data: ', error);
        });
    }
  };
  


  const displayContent = (content) => {
    setSelectedContent(content);
    setSelectedContentType(content.type);
    setSelectedContentUrl(content.fileUrl);
  };

  const renderModalContent = (content) => {
    if (!content) {
      return <p>No content to display</p>;
    }

    const contentHeight = "900px"; // Adjust as needed

    switch (content.type) {
      case 'pdf':
        return (
          <div>
            <iframe
              src={content.fileUrl}
              style={{ width: "100%", height: contentHeight }}
              title="PDF Viewer"
            ></iframe>
          </div>
        );
      case 'ppt':
      case 'docx':
        return (
          <div>
            <iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(content.fileUrl)}`}
              style={{ width: "100%", height: contentHeight }}
            ></iframe>
          </div>
        );
      case 'video':
        return (
          <div>
            <video width="100%" height={contentHeight} controls>
              <source src={content.fileUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        );
      case 'audio':
        return (
          <div>
            <audio controls style={{ width: "100%" }}>
              <source src={content.fileUrl} type="audio/mpeg" />
              Your browser does not support the audio tag.
            </audio>
          </div>
        );
      case 'text':
        return (
          <div style={{ height: contentHeight, overflowY: "auto" }}>
            <Typography variant="body1" dangerouslySetInnerHTML={{ __html: content.fileUrl }} />
          </div>
        );
      default:
        return (
          <div>
            <iframe
              src={`https://www.youtube.com/embed/${extractYouTubeVideoId(content.fileUrl)}`}
              title="YouTube Video"
              style={{ width: "100%", height: contentHeight }}
            ></iframe>
          </div>
        );
    }
  };


  return (
<div
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '-5px',
    }}
    >
  <Box  maxWidth="1300px" width="100%" >
        <Paper
          elevation={3}
          sx={{
            p: 2,
            m: 1,
            // background: "#f0f4f8",
            borderRadius: "20px",
            boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <Box>
              {/* Section Title */}
              <h3
                style={{
                  fontSize: '24px',
                  color: '#03396c',
                  fontWeight: '600',
                  marginBottom: '0',
                  marginRight: '20px',
                }}
              >
                Curriculum List
              </h3>
              <hr
                style={{
                  marginTop: '5px',
                  marginBottom: '10px',
                  borderTop: '2px solid #ddd',
                }}
              />
              {/* Card Grid */}
              <Grid container spacing={3}>
                {curriculumData.map((curriculum) => (
                  <Grid item xs={12} sm={6} md={4} key={curriculum.id}>
                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      transition={{ duration: 0.3 }}
                    >
                      <Card
                        onClick={() => handleShowModal(curriculum)}
                        sx={{
                          p: 3,
                          height: "100%",
                          borderRadius: "16px",
                          background: selectedContent?.id === curriculum.id
                            ? "linear-gradient(135deg, #0f2027, #203a43, #2c5364)"
                            : "#ffffff",
                          color: selectedContent?.id === curriculum.id ? "#ffffff" : "#111",
                          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          transition: "all 0.3s ease-in-out",
                          "&:hover": {
                            boxShadow: "0 12px 25px rgba(0, 0, 0, 0.2)",
                          },
                        }}
                      >
                        {/* Section Name */}
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            mb: 2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {curriculum.sectionName}
                        </Typography>

                        {/* Delete Button */}
                        <Box sx={{ textAlign: "right" }}>
                          <Tooltip title="Delete">

                          <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setCurriculumToDelete(curriculum); // Set the selected curriculum
                                setOpenDeleteDialog(true); // Open the dialog
                              }}
                              sx={{
                                color: "#fff",
                                backgroundColor: "#e63946",
                                "&:hover": {
                                  backgroundColor: "#d62828",
                                },
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                              }}
                            >
                              <FaTrash />
                            </IconButton>

                          </Tooltip>
                        </Box>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
        </Paper>

      </Box>

      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this curriculum?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}   color="primary"
  variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => confirmDelete()}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        
        </DialogActions>
      </Dialog>
	  

      <Modal show={showModal} onHide={handleCloseModal} dialogClassName="modal-fullscreen">
        <Modal.Header closeButton>
          <Modal.Title>{modalContent ? modalContent.sectionName : 'Modal Title'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderModalContent(modalContent)}
        </Modal.Body>
        <Modal.Footer>
        <button variant="contained"
                        style={{
                          backgroundColor: buttonBackgroundColor,
                          color: "#fff",
                          border: "none",
                          padding: "10px 20px",
                          borderRadius: "8px",
                          fontSize: "16px",
                          cursor: "pointer",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                        }}
          
                        onClick={handleCloseModal}>
                        Close
                      </button>
        </Modal.Footer>
      </Modal>

      <div style={{ height: '40px' }}>

      </div>
    </div>

  );
};


const Managec = () => {

  const [submitted, setSubmitted] = useState(false);


  return (
    <div >
      <Header />
      <App setSubmitted={setSubmitted} />
      <div>
        <Key key={submitted} />
      </div>


    </div>
  );
};


export default Managec;


function renderDownloadButton(content, type) {
  // Check if the content type is not a YouTube link and type is defined
  if (type && type !== 'youtube') {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleDownload(content.fileUrl, type)}>
        Download {type.toUpperCase()}
      </Button>
    );
  }


  // No download button for YouTube links or if type is undefined
  return null;
}


function handleDownload(fileUrl, type) {
  // Implement download logic here
  if (type === 'text') {
    downloadTextFile(fileUrl, 'download.txt');
  } else if (type === 'pdf' || type === 'ppt') {
    downloadFile(fileUrl, `download.${type}`);
  } else {
    window.location.href = fileUrl; // This is a simple example; improve based on your requirements
  }
}




function downloadTextFile(htmlContent, fileName) {
  const element = document.createElement('a');


  // Convert HTML content to formatted plain text
  const plainTextContent = convertHtmlToPlainText(htmlContent);


  const file = new Blob([plainTextContent], { type: 'text/plain' });


  element.href = URL.createObjectURL(file);
  element.download = fileName;
  document.body.appendChild(element);
  element.click();
}


function convertHtmlToPlainText(htmlContent) {
  const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
  const textContent = doc.body.textContent || '';
  return decodeHtmlEntities(textContent);
}


function decodeHtmlEntities(text) {
  const element = document.createElement('div');
  element.innerHTML = text;
  return element.innerText;
}


function downloadFile(fileUrl, fileName) {
  fetch(fileUrl)
    .then(response => response.blob())
    .then(blob => {
      const element = document.createElement('a');
      const file = new Blob([blob], { type: 'application/octet-stream' });


      element.href = URL.createObjectURL(file);
      element.download = fileName;
      document.body.appendChild(element);
      element.click();
    })
    .catch(error => {
      console.error('Error downloading file:', error);
    });
}



